import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { LiteralsFacadeService } from 'src/app/shared/services/literals.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { BrandManagementFacadeService } from './brand-search.facade.service';

@Injectable({ providedIn: 'root' })
export class SearchBrandService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private paginatorFacadeService: PaginatorFacadeService,
    private literalsFacade: LiteralsFacadeService,
    private brandFacade: BrandManagementFacadeService,
  ) {}

  searchBrand(): Observable<QcResponseGrid> {
    const url =
      this.environmentFacadeService.getEnvironment() + '/rest/v1/tableProductBrands/findByFilter';

    return this.http.post<QcResponseGrid>(
      url,
      {
        criteriaList: [
          {
            criteriaType: 'BRAND_COUPONSET_CODE_CRITERIA',
            couponsetCode: this.brandFacade.selectedCouponSetCode,
          },
          {
            criteriaType: 'BRAND_CODE_CRITERIA',
            brandCode: this.brandFacade.brandCode,
          },
        ],
        pagination: {
          page: this.paginatorFacadeService.pageIndex + 1,
          pageSize: this.paginatorFacadeService.itemsNumber,
        },
        sorting: {
          sortingField:
            this.paginatorFacadeService.selectedSortField ===
            this.literalsFacade.literals.literals['liquid.search.sort.tags.creation_date']
              ? 'CREATION_DATE'
              : 'CREATION_DATE',
          sortingOrder:
            this.paginatorFacadeService.selectedOrder ===
            this.literalsFacade.literals.literals['liquid.search.sort.asc']
              ? 'ASC'
              : 'DESC',
        },
      },
      { withCredentials: true, context: new HttpContext().set(IS_SEARCH, true) },
    );
  }
}
